import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isTokenExpired } from './tokenUtils';
import PracticeContextSwitcher from '../components/PracticeContextSwitcher';
import AppRoutes from '../AppRoutes';
import ErrorBoundary from '../components/ErrorBoundary';
import { NotificationProvider } from '../contexts/NotificationContext';
import { rememberPostLoginRedirect } from '../utils/postLoginRedirect';

export default function BillingWorkspaceShell() {
  const { token, logout } = useAuth();
  const { pathname, search = '', hash = '' } = useLocation();
  if (!token || isTokenExpired(token)) {
    rememberPostLoginRedirect(`${pathname}${search}${hash}`);
    return <Navigate to="/login" replace />;
  }
  const allowed = pathname === '/revenue-cycle' || pathname.startsWith('/revenue-cycle/')
    || pathname.startsWith('/notifications/open/')
    || pathname.startsWith('/support/tickets/')
    || pathname === '/organization-invite' || pathname === '/select-context';
  if (!allowed) return <Navigate to="/revenue-cycle" replace />;
  return <div className="min-h-screen bg-[#f7f8f5] text-slate-900">
    <header className="flex items-center justify-between border-b bg-white px-6 py-3">
      <Link to="/revenue-cycle" className="font-semibold">Sena · Billing workspace</Link>
      <nav aria-label="Account" className="flex gap-4 text-sm">
        <Link to="/revenue-cycle/account">Account security</Link>
        <Link to="/revenue-cycle/notifications?organizationId=0">Notifications</Link>
        <Link to="/revenue-cycle/support">Support</Link>
        <button type="button" onClick={logout}>Sign out</button>
      </nav>
    </header>
    <PracticeContextSwitcher />
    <NotificationProvider><ErrorBoundary><AppRoutes /></ErrorBoundary></NotificationProvider>
  </div>;
}
